import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_PRICE_LIST_ITEM_NAME_COLLECTION_NAME = "price-list-item-name";

export const useRxCollectionPriceListItemName =
  (): RxCollection<PriceListItemName> | null =>
    useRxCollection<PriceListItemName>(
      RXDB_PRICE_LIST_ITEM_NAME_COLLECTION_NAME,
    );

type UseRxData = Parameters<typeof useRxData<PriceListItemName>>;
export type PriceListItemNameQueryConstructor = UseRxData["1"];

const PRICE_LIST_ITEM_NAME_SCHEMA_LITERAL = {
  title: "price list item name schema",
  version: 1,
  description: "A localised name for a price-list item",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    itemId: {
      type: "string",
      maxLength: 100,
    },
    language: {
      type: "string",
    },
    name: {
      type: "string",
    },
    meta: SYNCABLE_META,
  },
  required: ["id", "itemId", "language", "name", "meta"],
  indexes: ["itemId"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(PRICE_LIST_ITEM_NAME_SCHEMA_LITERAL);

export type PriceListItemName = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const PRICE_LIST_ITEM_NAME_SCHEMA: RxJsonSchema<PriceListItemName> =
  PRICE_LIST_ITEM_NAME_SCHEMA_LITERAL;
